import { getApiUrl } from '@utils/apiUrl';

const BASEURL = getApiUrl();

export async function authFetch(path, method, body, extraHeaders = []) {
  const headers = new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  });
  extraHeaders.forEach(([k, v]) => headers.set(k, v));

  const req = {
    method: method.toUpperCase(),
    credentials: 'include',
    headers,
  };
  if (req.method !== 'GET' && body != null) {
    req.body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  return fetch(`${BASEURL}${path}`, req);
}
